export const calcImpressions = (cost: number, cpm: number) => {
  return Math.trunc((cost / cpm) * 1000);
};

export const calcClicks = (cost: number, cpc: number) => {
  return Math.trunc(cost / cpc);
};
